import { Box, Typography, Image, MediaBox } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

const ProtectionPlanBanner = styled(MediaBox).attrs((props) => ({
  bg: props.theme.extendWarranty.protectionPlanBanner.bg,
}))``

const ProtectionCoverageJewlr = () => {
  return (
    <>
      <ProtectionPlanBanner greaterThanOrEqual="tablet" mb={6} pb={7} pt={5}>
        <Box margin="auto" maxWidth="1024px">
          <Box contain textAlign="center">
            <Image
              alt="Protection Coverage"
              src={`${sl.config.jewlr_asset_url}images/info/warranty/jewlr4-extend.png`}
              width="45%"
            />
            <Typography color="black" fontSize="32px">
              Add Protection Coverage
            </Typography>
          </Box>
        </Box>
      </ProtectionPlanBanner>
      <ProtectionPlanBanner lessThan="tablet" py={5} textAlign="center">
        <Image
          alt="Extend"
          mb={2}
          src={`${sl.config.jewlr_asset_url}images/info/warranty/jewlr4-extend-mobile.png`}
          width="52%"
        />
        <Typography color="black" fontSize="30px" px={6}>
          Add Protection Coverage
        </Typography>
      </ProtectionPlanBanner>
    </>
  )
}

export default ProtectionCoverageJewlr
